<template>
  <div class="kwDataConsole">
    <el-tabs v-model="roleNameActive" v-if="roleWorkPlatArr.length>1">
      <el-tab-pane v-for="(roleOne,roleIndex) in roleWorkPlatArr" :key="roleIndex" :label="roleOne.roleName" :name="'roleWorkPlat_'+roleIndex">
        <iframe :id="'roleWorkPlatArr_'+roleIndex" :style="'width:100%;height:'+(windowHeight-25)+'px;'" frameborder=0 name="showHere" scrolling=auto :src="roleOne.url" v-if="(roleOne.ifLoaded && (roleNameActive == 'roleWorkPlat_'+roleIndex))">
          <!-- <kw_look v-if="(roleOne.ifLoaded && (roleNameActive == 'roleWorkPlat_'+roleIndex))" :pageInfo="roleOne" :isLimitButton="true" ></kw_look> -->
        </iframe>
      </el-tab-pane>
    </el-tabs>
    <div v-else v-for="(roleOne,roleIndex) in roleWorkPlatArr" :key="roleIndex">
      <iframe  :id="'roleWorkPlatArr_'+roleIndex" :style="'width:100%;height:'+(windowHeight-25)+'px;'" frameborder=0 name="showHere" scrolling=auto :src="roleOne.url" v-if="(roleOne.ifLoaded && (roleNameActive == 'roleWorkPlat_'+roleIndex))">
        <!-- <kw_look v-if="(roleOne.ifLoaded && (roleNameActive == 'roleWorkPlat_'+roleIndex))" :pageInfo="roleOne" :isLimitButton="true" ></kw_look> -->
      </iframe>
    </div>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kwDataConsole',
  props: {
    msg: String
  },
  data() {
    return {
      windowHeight:500,
      loginInfo:{},
      //登录人 session中的信息
      sessionMap:null,
      //角色看板的信息
      roleWorkPlatArr:[],
      roleNameActive:"roleWorkPlat_0"
    };
  },
  created() {
    var that = this;
    this.windowHeight = window.innerHeight-60;
    //
    //绑定用户信息
    this.loginInfo = JSON.parse(localStorage.loginInfo);
    var programaSetInfo = pageUtils.getSessionParam("programaSetInfo");
    if(programaSetInfo) {
      this.programaSetInfo = JSON.parse(programaSetInfo);
    }
    if(localStorage.sessionMap) {
      this.sessionMap = JSON.parse(localStorage.sessionMap);
    }
    var roleWorkPlatArr = [];
    if(this.sessionMap && this.programaSetInfo) {
      var roleIds = this.sessionMap.roleIds;
      var roleIdArr = roleIds.split(",");
      var roleNames = this.sessionMap.roleNames;
      var roleNameArr = roleNames.split(",");
      for (let index = 0; index < roleIdArr.length; index++) {
        const roleIdOne = roleIdArr[index];
        const roleNameOne = roleNameArr[index];
        if(this.programaSetInfo.CASTING_TABLE_ID > 0 && this.programaSetInfo.CASTING_PAGE_ID > 0) {
          var roleJosn = {
            tableId: this.programaSetInfo.CASTING_TABLE_ID,
            pageId: this.programaSetInfo.CASTING_PAGE_ID,
            pageType:11,
            mainId: roleIdOne,
            ifLoaded:true,
            roleId:roleIdOne,
            roleName:roleNameOne
          };
          var kwParam = "";
          var lookParam = that.GLOBAL.lookParam;
          lookParam.forEach(key => {
              kwParam+=(roleJosn[key]?roleJosn[key]:"")+"_";
          });
          // kwParam = utils.kwBtoa(kwParam);
          roleJosn.url = "look?noHead=1&openWay=2&kw_param=" + kwParam;

          roleWorkPlatArr.push(roleJosn);
        }
      }
    }
    this.roleWorkPlatArr = roleWorkPlatArr;
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
  },
  methods: {
    listDataClick:function(pageInfo){
        if(pageInfo.pageId > 0) {
        var toListJson = {
            pageId: pageInfo.pageId,
            tableId: pageInfo.tableId,
            initCheckId: 0,
            callBackType: 0,
            dataMaxNum: 1,
            ctType:3,
            SourceDataId:pageInfo.homeSetId
        }
        pageUtils.toNewListPage(toListJson);
        }
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
